import React from 'react';
import styled from 'styled-components';
import { useChangeAwareEffect } from 'use-change-aware-effect';
import { SectionContainer, SectionTitle } from '../../shared/sectionable/styles';
import propTypes from '../common/prop-types';
import Details from './fees-and-pricing-components/details';
import { scrollIfHashMatch } from '../../shared/navigation/utils';
import useFundStateStore from '../common/fund-state-hook';

const Container = styled(SectionContainer)`
  margin-top: 24px;
  margin-bottom: 36px;

  ${props => (props.theme.isMobile ? `
    margin-top: 0;
    margin-bottom: 24px;
  ` : `
    &:not(:first-child) {
      border-top: 1px solid #d7dfe7;
      padding-top: 72px;
    }
  `)};
`;

const sectionName = 'fund-fees';

export default function FeesAndPricing({ fund }) {
  const set = useFundStateStore(state => state.set);

  useChangeAwareEffect(({ isMount }) => {
    isMount && scrollIfHashMatch(sectionName);
    set(state => {
      state.hasFeesPricing = true;
    });
  }, {});

  return (
    <Container name={sectionName}>
      <SectionTitle>fees & pricing</SectionTitle>
      <Details fund={fund} />
    </Container>
  );
}

/* eslint-disable-next-line react/require-default-props */
FeesAndPricing.propTypes = { fund: propTypes.fund };
